import actionCreatorFactory from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/ACCOUNTROLEDOCUMENTPOINTER`
);
export type APIError = ApiFieldError;
export type createDocumentPointerActionPayload = any;
export type updateDocumentPointerParams = any;
export const createDocumentPointerActions = actionCreator.async<
  createDocumentPointerActionPayload,
  any,
  APIError[]
>(`create`);

export const describeDocumentPointerByRoleActions = actionCreator.async<
  any,
  any,
  APIError[]
>(`get-all`);

export const deleteDocumentPointerActions = actionCreator.async<
  { docPtrID: string },
  {},
  APIError[]
>(`delete`);
export const updateDocumentPointerActions = actionCreator.async<
  updateDocumentPointerParams,
  any,
  APIError[]
>(`update`);
